/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountType,
  DiscountTypeOptional,
  DiscountTypeMetaI,
  DiscountTypeTrackedI,
} from "./discount-type";
import { DiscountTypeTracked, DiscountTypeMeta } from "./discount-type";

/**
 *
 * @export
 * @interface LineItemDiscountInstanceBase
 */
export interface LineItemDiscountInstanceBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountInstanceBase
   */
  isApplied?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountInstanceBase
   */
  isAutoApplied?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountInstanceBase
   */
  isUnapplied?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountInstanceBase
   */
  isAutoAddProcessed?: boolean;
  /**
   *
   * @type {DiscountType}
   * @memberof LineItemDiscountInstanceBase
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountInstanceBase
   */
  specifiedCents?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemDiscountInstanceBase
   */
  specifiedPercent?: string;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountInstanceBase
   */
  amountBaseCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountInstanceBase
   */
  amountTotalCents?: number;
}

export interface LineItemDiscountInstanceBase extends LineItemDiscountInstanceBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountInstanceBase
   */
  isApplied?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountInstanceBase
   */
  isAutoApplied?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountInstanceBase
   */
  isUnapplied?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountInstanceBase
   */
  isAutoAddProcessed?: boolean;
  /**
   *
   * @type {DiscountType}
   * @memberof LineItemDiscountInstanceBase
   */
  discountType: DiscountType;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountInstanceBase
   */
  specifiedCents?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemDiscountInstanceBase
   */
  specifiedPercent?: string;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountInstanceBase
   */
  amountBaseCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountInstanceBase
   */
  amountTotalCents?: number;
}

export interface LineItemDiscountInstanceBaseTrackedI {
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountInstanceBase
   */
  isApplied?: boolean;
  isAppliedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountInstanceBase
   */
  isAutoApplied?: boolean;
  isAutoAppliedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountInstanceBase
   */
  isUnapplied?: boolean;
  isUnappliedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountInstanceBase
   */
  isAutoAddProcessed?: boolean;
  isAutoAddProcessedIsSet: boolean;
  /**
   *
   * @type {DiscountType}
   * @memberof LineItemDiscountInstanceBase
   */
  discountType?: DiscountType;
  discountTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountInstanceBase
   */
  specifiedCents?: number;
  specifiedCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemDiscountInstanceBase
   */
  specifiedPercent?: string;
  specifiedPercentIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountInstanceBase
   */
  amountBaseCents?: number;
  amountBaseCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountInstanceBase
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
}

transformDatesMap.set(
  "LineItemDiscountInstanceBase",
  function (model: LineItemDiscountInstanceBase) {},
);

export type LineItemDiscountInstanceBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isApplied: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isAutoApplied: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isUnapplied: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isAutoAddProcessed: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  discountType: PropertyMeta<DiscountTypeMetaI>;
  //isDate: false
  //isDatetime: false
  specifiedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  specifiedPercent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  amountBaseCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
}>;

export var LineItemDiscountInstanceBaseMeta: LineItemDiscountInstanceBaseMetaI =
  {} as LineItemDiscountInstanceBaseMetaI;
LineItemDiscountInstanceBaseMeta = typeMeta("LineItemDiscountInstanceBase", {
  isApplied: propertyMeta(
    "isApplied",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isAutoApplied: propertyMeta(
    "isAutoApplied",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isUnapplied: propertyMeta(
    "isUnapplied",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isAutoAddProcessed: propertyMeta(
    "isAutoAddProcessed",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  discountType: propertyMeta(
    "discountType",
    false,
    true,
    false,
    DiscountTypeMeta,
  ),
  specifiedCents: propertyMeta(
    "specifiedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  specifiedPercent: propertyMeta(
    "specifiedPercent",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  amountBaseCents: propertyMeta(
    "amountBaseCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = LineItemDiscountInstanceBaseMeta;

registerMeta(() => {});

export class LineItemDiscountInstanceBaseTracked implements LineItemDiscountInstanceBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  isApplied__I?: boolean = undefined;
  isAppliedIsSet: boolean = false;
  set isApplied(v: undefined | boolean) {
    if (v !== undefined) {
      this.isApplied__I = v;
      this.isAppliedIsSet = true;
    } else {
      this.isApplied__I = v || undefined;
      this.isAppliedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isApplied() {
    return this.isApplied__I;
  }
  isAutoApplied__I?: boolean = undefined;
  isAutoAppliedIsSet: boolean = false;
  set isAutoApplied(v: undefined | boolean) {
    if (v !== undefined) {
      this.isAutoApplied__I = v;
      this.isAutoAppliedIsSet = true;
    } else {
      this.isAutoApplied__I = v || undefined;
      this.isAutoAppliedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isAutoApplied() {
    return this.isAutoApplied__I;
  }
  isUnapplied__I?: boolean = undefined;
  isUnappliedIsSet: boolean = false;
  set isUnapplied(v: undefined | boolean) {
    if (v !== undefined) {
      this.isUnapplied__I = v;
      this.isUnappliedIsSet = true;
    } else {
      this.isUnapplied__I = v || undefined;
      this.isUnappliedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isUnapplied() {
    return this.isUnapplied__I;
  }
  isAutoAddProcessed__I?: boolean = undefined;
  isAutoAddProcessedIsSet: boolean = false;
  set isAutoAddProcessed(v: undefined | boolean) {
    if (v !== undefined) {
      this.isAutoAddProcessed__I = v;
      this.isAutoAddProcessedIsSet = true;
    } else {
      this.isAutoAddProcessed__I = v || undefined;
      this.isAutoAddProcessedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isAutoAddProcessed() {
    return this.isAutoAddProcessed__I;
  }
  discountType__I?: DiscountType = undefined;
  discountTypeIsSet: boolean = false;
  set discountType(v: undefined | DiscountType) {
    if (v !== undefined) {
      this.discountType__I = v;
      this.discountTypeIsSet = true;
    } else {
      this.discountType__I = v || undefined;
      this.discountTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get discountType() {
    return this.discountType__I;
  }
  specifiedCents__I?: number = undefined;
  specifiedCentsIsSet: boolean = false;
  set specifiedCents(v: undefined | number) {
    if (v !== undefined) {
      this.specifiedCents__I = v;
      this.specifiedCentsIsSet = true;
    } else {
      this.specifiedCents__I = v || undefined;
      this.specifiedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get specifiedCents() {
    return this.specifiedCents__I;
  }
  specifiedPercent__I?: string = undefined;
  specifiedPercentIsSet: boolean = false;
  set specifiedPercent(v: undefined | string) {
    if (v !== undefined) {
      this.specifiedPercent__I = v;
      this.specifiedPercentIsSet = true;
    } else {
      this.specifiedPercent__I = v || undefined;
      this.specifiedPercentIsSet = false;
    }
    this.changeTracker = true;
  }
  get specifiedPercent() {
    return this.specifiedPercent__I;
  }
  amountBaseCents__I?: number = undefined;
  amountBaseCentsIsSet: boolean = false;
  set amountBaseCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountBaseCents__I = v;
      this.amountBaseCentsIsSet = true;
    } else {
      this.amountBaseCents__I = v || undefined;
      this.amountBaseCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountBaseCents() {
    return this.amountBaseCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  constructor(
    config?: LineItemDiscountInstanceBaseOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: LineItemDiscountInstanceBaseOptional,
    options?: AssignOptions,
  ): LineItemDiscountInstanceBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isApplied && this.isAppliedApplyFilter(optionsRequired.filter)) {
      this.isApplied = config.isApplied;
      if (optionsRequired.unassign) this.isAppliedIsSet = false;
      else this.isAppliedIsSet = true;
    }
    if (
      config.isAutoApplied &&
      this.isAutoAppliedApplyFilter(optionsRequired.filter)
    ) {
      this.isAutoApplied = config.isAutoApplied;
      if (optionsRequired.unassign) this.isAutoAppliedIsSet = false;
      else this.isAutoAppliedIsSet = true;
    }
    if (
      config.isUnapplied &&
      this.isUnappliedApplyFilter(optionsRequired.filter)
    ) {
      this.isUnapplied = config.isUnapplied;
      if (optionsRequired.unassign) this.isUnappliedIsSet = false;
      else this.isUnappliedIsSet = true;
    }
    if (
      config.isAutoAddProcessed &&
      this.isAutoAddProcessedApplyFilter(optionsRequired.filter)
    ) {
      this.isAutoAddProcessed = config.isAutoAddProcessed;
      if (optionsRequired.unassign) this.isAutoAddProcessedIsSet = false;
      else this.isAutoAddProcessedIsSet = true;
    }
    if (
      config.discountType &&
      this.discountTypeApplyFilter(optionsRequired.filter)
    ) {
      this.discountType = config.discountType;
      if (optionsRequired.unassign) this.discountTypeIsSet = false;
      else this.discountTypeIsSet = true;
    }
    if (
      config.specifiedCents &&
      this.specifiedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.specifiedCents = config.specifiedCents;
      if (optionsRequired.unassign) this.specifiedCentsIsSet = false;
      else this.specifiedCentsIsSet = true;
    }
    if (
      config.specifiedPercent &&
      this.specifiedPercentApplyFilter(optionsRequired.filter)
    ) {
      this.specifiedPercent = config.specifiedPercent;
      if (optionsRequired.unassign) this.specifiedPercentIsSet = false;
      else this.specifiedPercentIsSet = true;
    }
    if (
      config.amountBaseCents &&
      this.amountBaseCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountBaseCents = config.amountBaseCents;
      if (optionsRequired.unassign) this.amountBaseCentsIsSet = false;
      else this.amountBaseCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemDiscountInstanceBaseTrackedI {
    const cloned = {} as LineItemDiscountInstanceBaseTrackedI;
    if (
      this.isAppliedIsSetDeep() &&
      this.isAppliedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isAppliedIsSet = true;
      cloned.isApplied = this.isApplied;
    } else {
      //cloned.isAppliedIsSet = false
    }
    if (
      this.isAutoAppliedIsSetDeep() &&
      this.isAutoAppliedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isAutoAppliedIsSet = true;
      cloned.isAutoApplied = this.isAutoApplied;
    } else {
      //cloned.isAutoAppliedIsSet = false
    }
    if (
      this.isUnappliedIsSetDeep() &&
      this.isUnappliedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isUnappliedIsSet = true;
      cloned.isUnapplied = this.isUnapplied;
    } else {
      //cloned.isUnappliedIsSet = false
    }
    if (
      this.isAutoAddProcessedIsSetDeep() &&
      this.isAutoAddProcessedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isAutoAddProcessedIsSet = true;
      cloned.isAutoAddProcessed = this.isAutoAddProcessed;
    } else {
      //cloned.isAutoAddProcessedIsSet = false
    }
    if (
      this.discountTypeIsSetDeep() &&
      this.discountTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountTypeIsSet = true;
      cloned.discountType = this.discountType;
    } else {
      //cloned.discountTypeIsSet = false
    }
    if (
      this.specifiedCentsIsSetDeep() &&
      this.specifiedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.specifiedCentsIsSet = true;
      cloned.specifiedCents = this.specifiedCents;
    } else {
      //cloned.specifiedCentsIsSet = false
    }
    if (
      this.specifiedPercentIsSetDeep() &&
      this.specifiedPercentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.specifiedPercentIsSet = true;
      cloned.specifiedPercent = this.specifiedPercent;
    } else {
      //cloned.specifiedPercentIsSet = false
    }
    if (
      this.amountBaseCentsIsSetDeep() &&
      this.amountBaseCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountBaseCentsIsSet = true;
      cloned.amountBaseCents = this.amountBaseCents;
    } else {
      //cloned.amountBaseCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemDiscountInstanceBaseTrackedI {
    if (!this.isAppliedApplyFilter(filter)) this.isAppliedIsSet = false;

    if (!this.isAutoAppliedApplyFilter(filter)) this.isAutoAppliedIsSet = false;

    if (!this.isUnappliedApplyFilter(filter)) this.isUnappliedIsSet = false;

    if (!this.isAutoAddProcessedApplyFilter(filter))
      this.isAutoAddProcessedIsSet = false;

    if (!this.discountTypeApplyFilter(filter)) this.discountTypeIsSet = false;

    if (!this.specifiedCentsApplyFilter(filter))
      this.specifiedCentsIsSet = false;

    if (!this.specifiedPercentApplyFilter(filter))
      this.specifiedPercentIsSet = false;

    if (!this.amountBaseCentsApplyFilter(filter))
      this.amountBaseCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    return this;
  }
  isAppliedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountInstanceBaseMeta.isApplied,
      LineItemDiscountInstanceBaseMeta,
      this.isApplied,
      this,
    );
  }
  isAppliedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isAppliedIsSet && this.isAppliedApplyFilter(filter)) return true;

    return false;
  }
  isAutoAppliedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountInstanceBaseMeta.isAutoApplied,
      LineItemDiscountInstanceBaseMeta,
      this.isAutoApplied,
      this,
    );
  }
  isAutoAppliedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isAutoAppliedIsSet && this.isAutoAppliedApplyFilter(filter))
      return true;

    return false;
  }
  isUnappliedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountInstanceBaseMeta.isUnapplied,
      LineItemDiscountInstanceBaseMeta,
      this.isUnapplied,
      this,
    );
  }
  isUnappliedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isUnappliedIsSet && this.isUnappliedApplyFilter(filter))
      return true;

    return false;
  }
  isAutoAddProcessedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountInstanceBaseMeta.isAutoAddProcessed,
      LineItemDiscountInstanceBaseMeta,
      this.isAutoAddProcessed,
      this,
    );
  }
  isAutoAddProcessedIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.isAutoAddProcessedIsSet &&
      this.isAutoAddProcessedApplyFilter(filter)
    )
      return true;

    return false;
  }
  discountTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountInstanceBaseMeta.discountType,
      LineItemDiscountInstanceBaseMeta,
      this.discountType,
      this,
    );
  }
  discountTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountTypeIsSet && this.discountTypeApplyFilter(filter))
      return true;

    return false;
  }
  specifiedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountInstanceBaseMeta.specifiedCents,
      LineItemDiscountInstanceBaseMeta,
      this.specifiedCents,
      this,
    );
  }
  specifiedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.specifiedCentsIsSet && this.specifiedCentsApplyFilter(filter))
      return true;

    return false;
  }
  specifiedPercentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountInstanceBaseMeta.specifiedPercent,
      LineItemDiscountInstanceBaseMeta,
      this.specifiedPercent,
      this,
    );
  }
  specifiedPercentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.specifiedPercentIsSet && this.specifiedPercentApplyFilter(filter))
      return true;

    return false;
  }
  amountBaseCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountInstanceBaseMeta.amountBaseCents,
      LineItemDiscountInstanceBaseMeta,
      this.amountBaseCents,
      this,
    );
  }
  amountBaseCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountBaseCentsIsSet && this.amountBaseCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountInstanceBaseMeta.amountTotalCents,
      LineItemDiscountInstanceBaseMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isAppliedIsSetDeep(filter)) return true;
    if (this.isAutoAppliedIsSetDeep(filter)) return true;
    if (this.isUnappliedIsSetDeep(filter)) return true;
    if (this.isAutoAddProcessedIsSetDeep(filter)) return true;
    if (this.discountTypeIsSetDeep(filter)) return true;
    if (this.specifiedCentsIsSetDeep(filter)) return true;
    if (this.specifiedPercentIsSetDeep(filter)) return true;
    if (this.amountBaseCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
